import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";
import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { QuestionOptionDateTabbedTimeSelectionEnabled } from "../date-tabbed-time-selection-enabled";
import { useOptionDateTabbedTimeSelectionEnabled } from "../date-tabbed-time-selection-enabled/hooks";
import { QuestionOptionMultiSubOptionSelectable } from "../multi-sub-option-selectable";
import { useOptionMultiSubOptionSelectable } from "../multi-sub-option-selectable/hooks";
import { useOptionUseAsSubOption } from "../use-as-sub-option/hooks";

import type { StandardOptionCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	subOption: StandardOptionCategoriesAndManagerStore["subOption"];
};

export const QuestionOptionSubOptionDisplaySettings = ({ subOption }: Props) => {
	const { useAsSubOption } = useOptionUseAsSubOption();

	const {
		multiSubOptionSelectable,
		onSetMultiSubOptionSelectable,
		isEdited: isEdited_multiSubOptionSelectable,
		hasError: hasError_multiSubOptionSelectable,
	} = useOptionMultiSubOptionSelectable();

	const {
		isDateTabbedTimeSelectionEnabled,
		onSetIsDateTabbedTimeSelectionEnabled,
		isEnabled: isDateTabbedTimeSelectionEnabledEnabled,
		isEdited: isEdited_isDateTabbedTimeSelectionEnabled,
		hasError: hasError_isDateTabbedTimeSelectionEnabled,
	} = useOptionDateTabbedTimeSelectionEnabled();

	if (!useAsSubOption.value) {
		return null;
	}

	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="予約画面での表示" categoryStore={subOption}>
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title="サブオプションの選択方法"
				guide="ゲストが選択できるサブオプションの数を設定します。"
				isEdited={isEdited_multiSubOptionSelectable}
				hasError={hasError_multiSubOptionSelectable}
				inputChildren={
					<QuestionOptionMultiSubOptionSelectable
						multiSubOptionSelectable={multiSubOptionSelectable}
						onSetMultiSubOptionSelectable={onSetMultiSubOptionSelectable}
					/>
				}
			/>

			<FeatureIslandCategoryQuestionForMain
				required={false}
				title="予約画面での表示タイミング"
				guide="ゲストの予約画面で、サブオプションを表示するタイミングを設定します。"
				isEdited={isEdited_isDateTabbedTimeSelectionEnabled}
				hasError={hasError_isDateTabbedTimeSelectionEnabled}
				inputChildren={
					<QuestionOptionDateTabbedTimeSelectionEnabled
						isDateTabbedTimeSelectionEnabled={isDateTabbedTimeSelectionEnabled}
						onSetIsDateTabbedTimeSelectionEnabled={onSetIsDateTabbedTimeSelectionEnabled}
						isEnabled={isDateTabbedTimeSelectionEnabledEnabled}
					/>
				}
			/>
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionOptionSubOptionDisplaySettings.displayName = "QuestionOptionSubOptionDisplaySettings";
